'use strict';
var parent = require('../../actual/instance/keys');

module.exports = parent;
